import React from 'react';
import styled from 'styled-components';
import {
  FaGlobe,
  FaFacebookF,
  FaInstagram,
  FaUserFriends,
  FaGoogle,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkedAlt,
  FaWalking,
  FaYelp,
  FaTwitter,
  FaTiktok,
  FaLinkedin,
  FaSeedling,
  FaBullhorn,
  FaHandshake,
  FaSms,
} from 'react-icons/fa';

const ORIGIN_CONFIG = [
  { match: /facebook|fb\b|meta/, label: 'Facebook', color: '#1877F2', Icon: FaFacebookF },
  { match: /instagram|insta|ig\b/, label: 'Instagram', color: '#E1306C', Icon: FaInstagram },
  { match: /tiktok/, label: 'TikTok', color: '#000000', Icon: FaTiktok },
  { match: /twitter|^x$|x\.com/, label: 'Twitter', color: '#1DA1F2', Icon: FaTwitter },
  { match: /linkedin/, label: 'LinkedIn', color: '#0A66C2', Icon: FaLinkedin },
  { match: /yelp/, label: 'Yelp', color: '#D32323', Icon: FaYelp },
  { match: /google|gmb|maps/, label: 'Google', color: '#EA4335', Icon: FaGoogle },
  { match: /referr|word.of.mouth|friend/, label: 'Referral', color: '#27AE60', Icon: FaUserFriends },
  { match: /website|web|site|landing/, label: 'Website', color: '#3498DB', Icon: FaGlobe },
  { match: /phone|call|inbound/, label: 'Phone', color: '#16A085', Icon: FaPhoneAlt },
  { match: /sms|text/, label: 'SMS', color: '#9B59B6', Icon: FaSms },
  { match: /email|mail/, label: 'Email', color: '#F39C12', Icon: FaEnvelope },
  { match: /walk|in.person|onsite/, label: 'Walk-in', color: '#E67E22', Icon: FaWalking },
  { match: /map|drive.by|drive by/, label: 'Drive-by', color: '#8E44AD', Icon: FaMapMarkedAlt },
  { match: /ad|campaign|paid|promo/, label: 'Ad', color: '#E84393', Icon: FaBullhorn },
  { match: /partner|vendor/, label: 'Partner', color: '#2ECC71', Icon: FaHandshake },
];

const DEFAULT_CONFIG = { color: '#F69620', Icon: FaSeedling };

const getOriginConfig = (originName) => {
  if (!originName) return null;
  const normalized = String(originName).toLowerCase();
  const found = ORIGIN_CONFIG.find(c => c.match.test(normalized));
  return found || DEFAULT_CONFIG;
};

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 12px;
  font-size: ${p => (p.size === 'sm' ? '0.68rem' : '0.75rem')};
  font-weight: 600;
  line-height: 1.2;
  background: ${p => p.color}22;
  color: ${p => p.color};
  border: 1px solid ${p => p.color}44;
  white-space: nowrap;
  vertical-align: middle;

  svg {
    font-size: ${p => (p.size === 'sm' ? '0.65rem' : '0.75rem')};
    flex-shrink: 0;
  }
`;

const OriginBadge = ({ origin, size, style, title }) => {
  const originName =
    typeof origin === 'string'
      ? origin
      : origin?.origin_name || origin?.name;

  if (!originName) return null;

  const config = getOriginConfig(originName);
  const { color, Icon } = config;

  return (
    <Badge color={color} size={size} style={style} title={title || `Origin: ${originName}`}>
      <Icon />
      {originName}
    </Badge>
  );
};

export default OriginBadge;
